import style from "./mainArticle1.module.scss";
import quotationMarkLeft from "../../../assets/images/main/article1/section4/double_quotation_marks_left.png";
import quotationMarkRight from "../../../assets/images/main/article1/section4/double_quotation_marks_right.svg";
import roadCharacter1 from "../../../assets/images/main/article1/section4/road_character1.png";
import roadCharacter2 from "../../../assets/images/main/article1/section4/road_character2.png";
import roadCharacter3 from "../../../assets/images/main/article1/section4/road_character3.png";
import dcasMiniLogo from "../../../assets/images/logo/dcas_white_logo.svg";
import kpassMiniLogo from "../../../assets/images/logo/kpass_white_logo_mini.svg";
import { useRef, useState } from "react";
import { useShowOrHide } from "../../../hooks/useShowOrHide";
import { StrongTextStyle, HighLightStyle } from "../../common/StyledCommonComponents";
import { Trans, useTranslation } from "react-i18next";
import { useUserAgent } from "../../../hooks/hooks";

export function Article1Section4() {
  const { t } = useTranslation(["parentsWish"]);
  const mainPartRef = useRef<HTMLDivElement>(null);
  const roadItemRef = useRef<HTMLImageElement>(null);
  const [showMainPart, setShowMainPart] = useState(false);
  const [showRoadItem, setShowRoadItem] = useState(false);
  const { isTablet } = useUserAgent();

  useShowOrHide({ refCurrent: mainPartRef.current, setShow: setShowMainPart });
  useShowOrHide({ refCurrent: roadItemRef.current, setShow: setShowRoadItem });

  return (
    <section className={style.section4}>
      <h2 className={"blind"}>{t("section4.heading2")}</h2>
      <div className={style.imageArea} />
      <div className={style.textArea}>
        <div className={`${style.paragraphs}`} ref={mainPartRef}>
          <img
            className={`${style.openingQuotationMark} ${showMainPart ? style.show : style.hide}`}
            src={quotationMarkLeft}
            alt={t("section4.openDoubleQuoteImgAlt")}
          />
          <div className={`${style.innerTextArea} ${showMainPart ? style.show : style.hide}`}>
            <p className={style.backgroundText}>
              {t("section4.text1")}
              <br />
              {t("section4.text2")}
            </p>
            <p className={style.targetText}>
              <Trans t={t} i18nKey={"section4.text4"} components={[<StrongTextStyle />]} />
            </p>
          </div>
          <img
            className={`${style.closingQuotationMark} ${showMainPart ? style.show : style.hide}`}
            src={quotationMarkRight}
            alt={t("section4.closeDoubleQuoteImgAlt")}
          />
        </div>
        <div className={`${style.paragraphs} ${style.noMarginTop}`} ref={mainPartRef}>
          <div className={`${style.explainParagraph}`}>
            <div className={`${style.aboutDcas}`}>
              <img className={`${style.dcasMiniLogo}`} src={dcasMiniLogo} alt={"dcasMiniLogo"} />
              <p className={`${style.firstExp}`}>
                <Trans t={t} i18nKey={"section4.dcas.desc.line1"} components={[<HighLightStyle />]} />
                {!isTablet ? <br /> : null}
                <Trans t={t} i18nKey={"section4.dcas.desc.line2"} components={[<HighLightStyle />]} />
                {!isTablet ? <br /> : null}
                {t("section4.dcas.desc.line3")}
              </p>
              <p className={`${style.secondExp}`}>
                {t("section4.dcas.subDesc.line1")}
                {!isTablet ? <br /> : null}
                {t("section4.dcas.subDesc.line2")}
                {!isTablet ? <br /> : null}
                {t("section4.dcas.subDesc.line3")}
              </p>
            </div>
            <div className={`${style.divider}`}></div>
            <div className={`${style.aboutKpass}`}>
              <img className={`${style.kpassMiniLogo}`} src={kpassMiniLogo} alt={"kpassMiniLogo"} />
              <p className={`${style.firstExp}`}>
                <Trans t={t} i18nKey={"section4.kpass.desc.line1"} components={[<HighLightStyle />]} />
                {!isTablet ? <br /> : null}
                <Trans t={t} i18nKey={"section4.kpass.desc.line2"} components={[<HighLightStyle />]} />
              </p>
              <p className={`${style.secondExp}`}>
                {t("section4.kpass.subDesc.line1")}
                {!isTablet ? <br /> : null}
                {t("section4.kpass.subDesc.line2")}
                {!isTablet ? <br /> : null}
                {t("section4.kpass.subDesc.line3")}
              </p>
            </div>
          </div>
        </div>
        <div className={style.roadPic}>
          <img
            className={`${style.character1} ${showRoadItem ? style.show : style.hide}`}
            src={roadCharacter1}
            alt={t("section4.planetCharacterImgAlt")}
            ref={roadItemRef}
          />
          <img
            className={`${style.character2} ${showRoadItem ? style.show : style.hide}`}
            src={roadCharacter2}
            alt={t("section4.noteCharacterImgAlt")}
          />
          <img
            className={`${style.character3} ${showRoadItem ? style.show : style.hide}`}
            src={roadCharacter3}
            alt={t("section4.pencilCharacterImgAlt")}
          />
        </div>
      </div>
    </section>
  );
}
